module.exports = __webpack_public_path__ + "static/media/img61.6d2d7aa9.jpg";